import { useTranslation } from "react-i18next";

export const OrderPlacementTabs = ({
  activeTab,
  setActiveTab,
  setBankPayment,
}: {
  activeTab: "ukraine" | "abroad";
  setActiveTab: React.Dispatch<React.SetStateAction<"ukraine" | "abroad">>;
  setBankPayment: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const { t } = useTranslation();

  return (
    <div className="order-placement__tabs">
      <div className="order-placement__tabs--wrapper">
        <div
          className={`order-placement__tab ${activeTab === "ukraine" ? "active" : ""}`}
          onClick={() => setActiveTab("ukraine")}
        >
          {t("ModalTabUkraine")}
        </div>
        <div
          className={`order-placement__tab ${activeTab === "abroad" ? "active" : ""}`}
          onClick={() => {
            setActiveTab("abroad");
            setBankPayment(true);
          }}
        >
          {t("ModalTabAbroad")}
        </div>
        <div className={`order-placement__tab--underline ${activeTab}`}></div>
      </div>
    </div>
  );
};
